import { useTranslation } from "react-i18next";
import { PickupDay } from "@/types/pickupDay";
import { OpeningHours } from "@/types/forms/auth/registerFormData.form";

const DAYS: Record<string, PickupDay> = {
  "0": "MONDAY",
  "1": "TUESDAY",
  "2": "WEDNESDAY",
  "3": "THURSDAY",
  "4": "FRIDAY",
};

type OpeningHoursDisplayProps = {
  openingHours?: OpeningHours;
};

export const OpeningHoursDisplay = ({ openingHours }: OpeningHoursDisplayProps) => {
  const { t } = useTranslation(["boClients", "enums"]);

  if (!openingHours) {
    return <p className="text-sm text-gray-500">{t("pickUpLocationOpeningHours.undefined")}</p>;
  }

  const sortedDays = Object.entries(openingHours)
    .filter(([, slots]) => slots && slots.length > 0)
    .sort(([a], [b]) => Number(a) - Number(b));

  if (sortedDays.length === 0) {
    return <p className="text-sm text-gray-500">{t("pickUpLocationOpeningHours.undefined")}</p>;
  }

  return (
    <div className="flex flex-col gap-1">
      {sortedDays.map(([day, slots]) => (
        <div key={day} className="flex flex-row gap-2 text-sm">
          <span className="w-20 text-base font-medium text-gray-700">
            {DAYS[day] && t(`enums:pickupDay.${DAYS[day]}`)}
          </span>
          <span className="text-base font-medium text-gray-700">
            {slots.map((slot, i) => (
              <span key={i}>
                {i > 0 && ", "}
                {t("pickUpLocationOpeningHours.slot", { open: slot.open, close: slot.close })}
              </span>
            ))}
          </span>
        </div>
      ))}
    </div>
  );
};
